import { DefaultUrlSerializer, UrlTree } from "@angular/router";
import { CustomQueryParams } from "./custom-query-params";

export class JsonQueryParamsUrlSerializer extends DefaultUrlSerializer {
    
    public override parse(url: string): UrlTree{        
            const tree = super.parse(url);

        if (tree.queryParams) {
                const customParams = tree.queryParams["params"];

            tree.queryParams = customParams ? JSON.parse(customParams) : {};
        }

        return tree;
    }

    public override serialize(tree: UrlTree): string {        
            if (tree.queryParams && Object.keys(tree.queryParams).length > 0) {
                const isCustomQueryParams = tree.queryParams instanceof CustomQueryParams;

            if (!isCustomQueryParams) {
                    const hasKeys = Object.keys(tree.queryParams).length > 0;
                if (hasKeys) {
                        const customParams = CustomQueryParams.Create(tree.queryParams);

                    tree.queryParams = customParams;                    
                }
            }
        }

        return super.serialize(tree);
    }
}